<template>
	<div>
		<a-modal :title="getTitle" :width="400" :visible="visible"  @cancel="handleCancel" v-dragModal>
			<template slot="footer" >
				<a-button  key="back"  @click="handleCancel">
					取消
				</a-button>
				<a-button  key="submit" type="primary" @click="onSubmit" :loading="confirmLoading">
					保存
				</a-button>
			</template>
			<a-spin :spinning="loading">
				<a-form-model :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18}">
					<a-form-model-item required label="分组名称">
						<a-input v-model="form.group_name" style="width:240px;" placeholder="请输入分组名称"></a-input>
					</a-form-model-item>
					<a-form-model-item label="排序" required>
						<a-input v-model="form.sort" style="width:100px;" placeholder="请输入排序"></a-input>
					</a-form-model-item>
				</a-form-model>
			</a-spin>
		</a-modal>
	</div>
</template>

<script>
	export default {
		props: {
			group_id: {
				type: Number,
				default: 0
			},
			visible:{
				type:Boolean,
				default:false,
			},
		},
		created() {
			if(this.group_id >0){
				this.getGroupDetail();
			}
		},
		data() {
			return {
				loading: false,
				confirmLoading: false,
				form: {
					group_id: 0,
					group_name: '',
					sort: 99,
				},
			}
		},
		methods: {
			//获取弹窗标题
			getTitle(){
				if(this.group_id > 0){
					return '修改分组';
				}
				return '添加分组';
			},
			//获取分组详情
			getGroupDetail(){
				if(this.loading==true) return;
				this.loading=true;
				if(this.group_id > 0){
					this.$http.api('platform/upload/getGroupDetail',{
						group_id: this.group_id,
					}).then(res=>{
						if(res.detail){
							this.form = res.detail;
						}
						this.loading=false;
					}).catch(res=>{
						console.log(res);
						this.loading=false;
					})
				}else{
					this.loading=false;
				}
			},
			/**
			 * 取消弹窗
			 */
			handleCancel() {
				this.$emit("cancel");
			},
			/*
			 * 提交数据
			 */
			onSubmit() {
				if(this.confirmLoading==true) return;
				this.confirmLoading=true;
				this.$http.api('platform/upload/addGroup',{
					group_id: this.form.group_id,
					group_name: this.form.group_name,
					sort: this.form.sort,
				}).then(res=>{
					this.$message.success('操作成功',1,()=>{
						this.confirmLoading=false;
						this.$emit("ok");
					})
				}).catch(res=>{
					console.log(res);
					this.confirmLoading=false;
				})
				
			},

		},
	}
</script>

<style>
</style>
